import axiosNest from '../../api/axiosNest';

/**
 * Kartoteka przewoźników — zapisy Trade (I.07): profil i kontakty.
 * Odpowiada `apps/api/src/carriers/carriers.controller.ts`.
 */

export interface CarrierProfileInput {
  taxId?: string | null;
  /** `null` = nieustalona. */
  active?: boolean | null;
  notes?: string | null;
}

export interface ContactInput {
  name?: string | null;
  role?: string | null;
  email?: string | null;
  phone?: string | null;
  channel?: string | null;
  ownerUserId?: number | null;
}

export interface CarrierContact extends ContactInput {
  id: number;
  source?: string | null;
  owner?: { id: number; username: string } | null;
}

export interface Owner {
  id: number;
  username: string;
}

const base = (id: number | string) => `/carriers/${id}`;

export async function updateCarrierProfile(id: number | string, input: CarrierProfileInput) {
  const { data } = await axiosNest.put(`${base(id)}/profile`, input);
  return data;
}

export async function addCarrierContact(id: number | string, input: ContactInput) {
  const { data } = await axiosNest.post(`${base(id)}/contacts`, input);
  return data;
}

export async function updateCarrierContact(
  id: number | string,
  contactId: number,
  input: ContactInput,
) {
  const { data } = await axiosNest.put(`${base(id)}/contacts/${contactId}`, input);
  return data;
}

export async function deleteCarrierContact(id: number | string, contactId: number) {
  await axiosNest.delete(`${base(id)}/contacts/${contactId}`);
}

export async function fetchContactOwners(): Promise<Owner[]> {
  const { data } = await axiosNest.get<Owner[]>('/carriers/contact-owners');
  return data;
}

/** Aktywność: trzy stany, bo „nie wiemy” to nie „aktywny”. */
export const ACTIVITY_CHOICES: Array<{ value: 'true' | 'false' | ''; label: string }> = [
  { value: '', label: 'nieustalona' },
  { value: 'true', label: 'współpracuje' },
  { value: 'false', label: 'nie współpracuje' },
];

export const activityFromChoice = (v: string): boolean | null =>
  v === 'true' ? true : v === 'false' ? false : null;

export const activityToChoice = (v: unknown): 'true' | 'false' | '' =>
  v === true ? 'true' : v === false ? 'false' : '';

export const activityLabel = (v: unknown): string =>
  ACTIVITY_CHOICES.find((c) => c.value === activityToChoice(v))?.label ?? 'nieustalona';
